import {showErrorNotification} from "../global/notifications";
import {closeKendoWindow} from "../global/kendoWindows";

const _company = $('#Company').val();
const _contract = $('#Contract').val();
let $parentGrid = null;
let $grid = null;

export const invoiceGridInit = (element) => {
    let $approveGrid = $(element);
    $grid = $(element);
    $parentGrid = $('.cash-grid');

    $approveGrid.kendoGrid({
        /*mobile: "phone",*/
        resizable: true, columns: [
            {
                field: 'Included', title: 'Selected', attributes: {class: ''}, type: 'boolean',
                template: function (dataItem) {
                    return `<div style="text-align: center;"><span class="k-icon k-icon-md ${dataItem.Included ? 'k-i-check-outline --green' : 'k-i-close-outline --red-dark'}"></span></div>`
                },
                width: 80
            }, {
                field: 'Id', title: 'Invoice', attributes: {class: ''}, template: function (dataItem) {
                    return `<div>${dataItem.InvoiceId} - ${dataItem.Description}</div>`;
                }
            }, {
                field: 'Amount', title: 'Amount', attributes: {class: ''},
                type: 'number',
                format: '{0: c2}'
            }, {
                field: 'Date',
                title: 'Date',
                attributes: {class: ''},
                type: 'date',
                format: '{0: M/d/yyyy}'
            }, {
                field: 'DsoDate',
                title: 'DSO Date',
                attributes: {class: ''},
                type: 'date',
                format: '{0: M/d/yyyy}'
            }, {
                field: 'AnticipatedDate',
                title: 'Anticipated Date',
                attributes: {class: ''},
                type: 'date',
                format: '{0: M/d/yyyy}'
            }
        ], dataSource: {
            autoSync: true, schema: {
                model: {
                    id: 'aid', fields: {
                        Included: {editable: false, type: 'boolean'},
                        Id: {editable: false, type: 'string'},
                        InvoiceId: {editable: false, type: 'string'},
                        Description: {editable: false, type: 'string'},
                        Amount: {editable: false, type: 'number'},
                        Date: {editable: false, type: 'date'},
                        DsoDate: {editable: false, type: 'date'},
                        AnticipatedDate: {editable: false, type: 'date'}
                    }
                }
            }, transport: {
                read: {
                    url: '/Account/Finance/GetInvoiceInfo',
                    type: 'GET',
                    dataType: 'json'
                }, parameterMap: function (data, type) {
                    let rs = {};
                    if (type === 'read') {
                        rs['contract'] = $('[name="Contract"]').val();
                        rs['week'] = $('[name="Week"]').val();
                        rs['isArAging'] = $('[name="IsArAging"]').val();
                        rs.customerId = $('[name="CustId"]').val();
                        return rs;
                    }
                }
            }
        }, dataBound: function (arg) {
            const $grid = arg.sender;
            const $element = $grid.element;
            const $rows = $element.find('tbody [role="row"]');

            $rows.css('cursor', 'pointer');

            $rows.on('click', function () {
                const $self = $(this);
                const $selected = $self.find('.k-icon.k-icon-md');
                const data = $approveGrid.data('kendoGrid').dataSource.data().find(function (element) {
                    return element.uid === $self.data('uid')
                });
                data.Included = !data.Included;
                if ($selected.hasClass('--green')) {
                    $selected.removeClass('k-i-check-outline --green').addClass('k-i-close-outline --red-dark');
                } else {
                    $selected.removeClass('k-i-close-outline --red-dark').addClass('k-i-check-outline --green');
                }
            })

            toggleAfterGrid($approveGrid);
        }, mobile: true, scrollable: true, sortable: {
            mode: 'multiple'
        }, filterable: false, editable: false, columnMenu: false,
        filter: function (e) {

        },
        noRecords: {
            template: "There are no invoices week"
        }
    })
}
const assignmentButtonEvent = ($self) => {
    const $form = $('form#InvoiceAssignmentForm');
    const k_this_window = $form.closest('.k-content');
    if ($form.length) {
        const $saveButton = $form.find('[data-role=save]');
        if ($saveButton.length) {
            $saveButton.unbind('click');
            $saveButton.on('click', function (e) {
                const $this = $(this);
                $this.hide();

                const moveList = $grid.data('kendoGrid').dataSource.data().filter(function (element) {
                    return element.Included
                });
                if (moveList.length === 0) {
                    showErrorNotification('No items have been selected');
                    $this.show();
                    return;
                }

                let moveListClone = cloneMoveList(moveList);

                const data = {
                    collectionInvoices: moveListClone,
                    assignmentDate: $('#AssignmentDate').val(),
                    comment: $('#Comments').val()
                };

                if (data.assignmentDate === '') {
                    showErrorNotification('Please enter an assignment date');
                    $this.show();
                    return;
                }

                saveMoveList(data)
                    .then(_ => $parentGrid.data('kendoGrid').dataSource.read())
                    .then(_ => closeKendoWindow(k_this_window))
                    .catch(error => {
                        showErrorNotification(error);
                        $this.show();
                    });
            })
        }
    }
}
const saveMoveList = (data) => {
    return new Promise((resolve, reject) => {
        $.post('/Account/Finance/SaveCashInvoiceAssignment', data, function (response) {
            if (response.success) {
                resolve();
            } else {
                reject(response.message);
            }
        })
    })
}
const cloneMoveList = (moveList) => {
    let moveListClone = [];
    let i = moveList.length;
    while (--i >= 0) {
        moveListClone.push({
            Included: true,
            Id: moveList[i].Id,
            InvoiceId: moveList[i].InvoiceId,
            Description: moveList[i].Description,
            Amount: moveList[i].Amount,
            Date: moveList[i].Date,
            DsoDate: moveList[i].DsoDate,
            AnticipatedDate: moveList[i].AnticipatedDate,
        });
    }

    return moveListClone;
}
const toggleAfterGrid = ($grid) => {
    if ($grid.data('kendoGrid').dataSource.data().length > 0) {
        $('.js-after-grid').show();
        assignmentButtonEvent();
    } else {
        $('.js-after-grid').hide();
    }
}